import {DialogTitle} from '@headlessui/react'
import {useContext} from 'react'

import {twMerge} from '@sdox/utils'

import {DialogContext} from './Dialog'

import type {DialogTitleProps} from '@headlessui/react'

export interface DialogHeadingProps extends DialogTitleProps {
  className?: string
}

export const DialogHeading = (props: DialogHeadingProps) => {
  const {children, className, ...restProps} = props
  const {size} = useContext(DialogContext)
  return (
    <DialogTitle
      className={twMerge(
        size === 'small' && 'text-h4',
        size === 'medium' && 'text-h3',
        className,
      )}
      {...restProps}
    >
      {children}
    </DialogTitle>
  )
}
